import {z} from 'zod';

export const dlqCountsResponseSchema = z.object({
  status: z.string(),
  data: z.object({
    visible: z.number(),
    inFlight: z.number(),
    redrivePolicy: z.string().optional(),
    messageRetentionPeriod: z.number(),
  }),
  timestamp: z.string(),
});
